import { External } from "./External";
import { Internal } from "./Internal";

export const Link = { External, Internal };
